import api from './axiosConfig';

const roundStatsService = {
  async getRoundStats(championshipId, type, value) {
    if (!type || !value) {
      throw new Error('Tipo (round/phase) e valor (número ou nome da fase) são obrigatórios.');
    }
    try {
      const response = await api.get(`/championships/${championshipId}/round/stats`, {
        params: { type, value }
      });
      // A API agora retorna { success: true, data: { ...stats, pendingMatches: [...] } }
      // Então, precisamos retornar o objeto `data` completo.
      return response.data.data; 
    } catch (error) {
      console.error('[roundStatsService] Erro ao buscar estatísticas da rodada:', error);
      throw error;
    }
  }
};

export default roundStatsService;